
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import {dictApi, manufactoryApi, roleApi, userApi} from "@/api/organization";
    import baseUrl, {imageUrl} from "@/constants";
    const {regionData} =require("@/js/region/region");
    import axios from "axios";

    @Component
    export default class UserDataOther extends Vue {
        title = "个人其他信息";

        // 0受教育经历  1从事计量技术工作经历 2人员计量从业资格情况 3参加计量业务培训经历 4专业技术资格情况 5计量专家任职情况 6计量专业技术工作情况 7著作、论文及重要技术报告 8奖励情况
        titleArr = ["受教育经历","从事计量技术工作经历","人员计量从业资格情况","参加计量业务培训经历","专业技术资格情况","计量专家任职情况","计量专业技术工作情况","著作、论文及重要技术报告","奖励情况",]
        toggleShow = [true,true,true,true,true,true,true,true,true]
        list = [[],[],[],[],[],[],[],[],[]]
        editDialog = [false,false,false,false,false,false,false,false,false,]
        rules = [
            {
                schoolName: [{ required: true, message: '请输入毕业院校', trigger: 'blur' }],
                cultlevel: [{ required: true, message: '请选择学历', trigger: 'change' }],
                studyMode: [{ required: true, message: '请选择学习形式', trigger: 'change' }],
                studyType: [{ required: true, message: '请选择学习类型', trigger: 'change' }],
                studyYears: [{ required: true, message: '请选择学制', trigger: 'change' }],
                eduStartDate: [{ required: true, message: '请选择入学日期', trigger: 'change' }],
                speciality: [{ required: true, message: '请选择所学专业', trigger: 'change' }],
                degree: [{ required: true, message: '请选择学位', trigger: 'change' }],
                signChar: [{ required: true, message: '请选择学历标识', trigger: 'change' }],
                degreeCertNo: [{ required: true, message: '请输入学位证书编号', trigger: 'blur' }],
                gradDate: [{ required: true, message: '请选择毕业日期', trigger: 'change' }],
                issueDate: [{ required: true, message: '请选择学位授予日期', trigger: 'change' }],
                diplomaCertNo: [{ required: true, message: '请输入毕业证书编号', trigger: 'blur' }],
                bkzyml: [{ required: true, message: '请选择学位授予门类', trigger: 'change' }],
                diploma: [{ required: true, message: '请上传毕业证照片', trigger: 'change' }],
                degreeCert: [{ required: true, message: '请上传学位学位证书照片', trigger: 'change' }],
            }
        ]

        form = [
            {
                sid: "",  //添加时为空，编辑时存在
                schoolName: "",  //毕业院校
                cultlevel: "",   //学历
                studyMode: "",  //学习形式
                studyType: "",  //学习类型
                studyYears: "",   //学制
                eduStartDate: "", //入学日期
                speciality: "",   //所学专业
                degree: "",  //学位
                signChar: "",   //学历标识
                degreeCertNo: "",  //学位证书编号
                gradDate: "",  //毕业日期
                issueDate: "",  //学位授予日期
                diplomaCertNo: "",  //毕业证书编号
                bkzyml: "",            //学位授予门类
                diploma: "",  //毕业证照片
                degreeCert: "",  //学位学位证书照片
            },
            {
                sid: "",  //添加时为空，编辑时存在
                schoolName: "",  //工作单位
                cultlevel: "",   //岗位
                studyMode: "",  //从事专业
                studyType: "",  //是否在岗
                studyYears: "",   //开始年月
                eduStartDate: "", //结束年月
            },
            {
                sid: "",  //添加时为空，编辑时存在
                schoolName: "",  //证书名称
                cultlevel: "",   //等级
                studyMode: "",  //证书编号
                studyType: "",  //发证机关
                studyYears: "",   //批准日期
                eduStartDate: "", //发证日期
                eduStartDate1: "", //有效期至
                eduStartDate2: "", //其他
                eduStartDate3: "", //证书照片
            },
            {
                sid: "",  //添加时为空，编辑时存在
                schoolName: "",  //培训类型
                cultlevel: "",   //培训形式
                studyMode: "",  //培训专题
                studyType: "",  //起始日期
                studyYears: "",   //结束日期
                eduStartDate: "", //培训学时
                speciality: "",   //考核等次
                degree: "",  //组织单位
                signChar: "",   //培训地点
            },
            {
                sid: "",  //添加时为空，编辑时存在
                schoolName: "",  //专业技术系列
                cultlevel: "",   //专业名称
                studyMode: "",  //资格名称
                studyType: "",  //编号
                studyYears: "",   //批文号
                eduStartDate: "", //授予日期
                speciality: "",   //评审机构
                degree: "",  //审批机构
                signChar: "",   //发证单位
                degreeCertNo: "",  //证书照片
            },
            {
                sid: "",  //添加时为空，编辑时存在
                schoolName: "",  //任职机构
                cultlevel: "",   //职务
                studyMode: "",  //专业类别
                studyType: "",  //证书编号
                studyYears: "",   //分支机构
                eduStartDate: "", //发证机关
                speciality: "",   //起始日期
                degree: "",  //有效期至
                degreeCertNo: "",  //证书照片
            },
            {
                sid: "",  //添加时为空，编辑时存在
                schoolName: "",  //工作项目
                cultlevel: "",   //级别
                studyMode: "",  //名称
                studyType: "",  //参与方式
                studyYears: "",   //名次
                eduStartDate: "", //起止年月
                eduStartDateEnd: "", //起止年月2
                speciality: "",   //完成情况
                degree: "",  //工作内容
            },
            {
                sid: "",  //添加时为空，编辑时存在
                schoolName: "",  //名称
                cultlevel: "",   //发表/出版日期
                studyMode: "",  //类别
                studyType: "",  //字数（千字）
                studyYears: "",   //级别
                eduStartDate: "", //刊载介质名称
                speciality: "",   //参与方式
                degree: "",  //刊号/书号
                signChar: "",   //个人排名
                degreeCertNo: "",  //检索验证网址
                gradDate: "",  //其他描述
                issueDate: "",  //照片
            },
            {
                sid: "",  //添加时为空，编辑时存在
                schoolName: "",  //名称
                cultlevel: "",   //授予单位
                studyMode: "",  //授予日期
                studyType: "",  //证书编号
                studyYears: "",   //授予级别
                eduStartDate: "", //奖励等次
                speciality: "",   //奖励排名
                degree: "",  //证书照片
            },
        ]



        addform = {
            idCard: "",  //身份证号
            name: "",  //姓名
            formerName: "",    //曾用名
            gender: 0,    //性别
            birthday: "",    //出生日期
            ethnicity: "",    //民族
            phone: "",    //手机号码
            nativePlace: "",    //籍贯
            nativePlaceArr: "",    //籍贯
            birthPlace: "",    //出生地
            birthPlaceArr: "",    //出生地
            education: "",    //最高学历
            degree: "",    //最高学位
            politicalStatus: "",    //政治面貌
            admissionTime: "",    //入党（团、派别）日期
            workStartTime: "",    //参加工作日期
            engagedStartTime: "",    //从事计量工作开始日期
            avatar: "",  //头像
        } as any
        dictTitle = {
            "C031": "ethnicity",  //民族
            "xl": "education",  //学历
            "xw": "degree",  //学位
            "C029": "politicalStatus",  //政治面貌
            "employee_category": "category",  //人员类别
            "jrbdwxs1": "enterForm",  //进入单位形式
            "rysf": "status",  //人员身份
            "xcsgz1": "workType",  //现在从事工作
            "xrzw": "post",  //现任行政职务
            "xrzj": "level",  //现行政职级
            "xrzg": "title",  //现技术职称资格
            "xpgw": "currentPosition",  //现聘职级
        } as any;
        dictList = {
            ethnicity: [],  //民族
            education: [],  //学历
            degree: [],  //学位
            politicalStatus: [],  //政治面貌
            category: [],  //人员类别
            enterForm: [],  //进入单位形式
            status: [],  //人员身份
            workType: [],  //现在从事工作
            post: [],  //现任行政职务
            level: [],  //现行政职级
            title: [],  //现技术职称资格
            currentPosition: [],  //现聘职级
        } as any
        baseUrl = baseUrl
        imageUrl = imageUrl
        headers = {Authorization:""}
        regionData = regionData
        roleArr = [];  //角色备选列表
        roleIds = [];  //选中的角色
        /**
         * 编辑的id
         * */
        @Prop() private id!: any;
        @Prop() private pageType!: any; //0添加  1编辑  2查看 3个人
        created() {
            if(this.id){
                this.init();
            }
        }
        init(){
            axios.all([
                    this.getDict("C031"),  //民族
                    this.getDict("xl"),
                    this.getDict("xw"),
                    this.getDict("C029"),
                ],
            ).then(axios.spread((acct,perms)=>{
                if(this.id != "0"){
                    this.loadDetail();
                }
            }))
        }
        loadDetail(){
            userApi.loadDetail({id: this.id}).then(r => {
                if (r.data.result === 0) {
                    const rData = r.data.data as any;
                    if(rData.userBaseInfo){
                        if(rData.userBaseInfo.nativePlace){
                            rData.userBaseInfo.nativePlaceArr = rData.userBaseInfo.nativePlace.split(",");
                        }
                        if(rData.userBaseInfo.birthPlace){
                            rData.userBaseInfo.birthPlaceArr = rData.userBaseInfo.birthPlace.split(",");
                        }
                        this.addform = rData.userBaseInfo;
                    }
                    if(rData.roleIds){
                        this.roleIds = rData.roleIds;
                    }else{
                        this.roleIds = [];
                    }
                }
            })
        }
        getDict(typeCode: string) {
            return dictApi.listDictItem({
                typeCode: typeCode
            }).then(r => {
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    if(this.dictTitle[typeCode]){
                        const b = this.dictTitle[typeCode] as string;
                        this.dictList[b] = rData;
                        if(rData.length>0){
                            if(this.addform[b] !== undefined){
                                this.addform[b] = rData[0].dictValue
                            }
                        }
                    }
                }
            })
        }
        //切换显隐
        toggleShowBtn(type: number){
            this.$set(this.toggleShow,type,!this.toggleShow[type])
        }
        //弹出编辑弹窗
        editBtn(type: number){
            this.$set(this.editDialog,type,true)
        }
        closeFail(type: number){
            let $form = this.$refs['form_'+type] as HTMLFormElement;
            $form.resetFields();
            this.$set(this.editDialog,type,false)
        }
        saveBtn(type: number){
            console.log(type);
            let form = this.$refs['form_'+type] as HTMLFormElement;
            form.validate((valid:any) => {
                if (valid) {
                    console.log(this.form[type])
                }
            })
        }
        //图片上传判断
        beforeImageUpload(file: any) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            if (!isJPG && !isPNG) {
                this.$message.error('上传图片只能是 JPG 或 PNG格式!');
            }
            return (isJPG || isPNG);
        }
        //毕业证照片
        handleSuccess00(res: any, fileny: any) {
            if (res.result === 0) {
                const rData = res.data;
                this.$set(this.form[0],'diploma',rData)
                this.$message.success("上传成功");
            }
        }
        //学位学位证书照片
        handleSuccess01(res: any, fileny: any) {
            if (res.result === 0) {
                const rData = res.data;
                this.$set(this.form[0],'degreeCert',rData)
                this.$message.success("上传成功");
            }
        }
    }
